import { Injectable } from '@angular/core';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { Urls } from 'projects/Autofacets-Core/src/app/utils/urls';
import {
  CallDealerLogsRequestModal,
  DealerWiseCallHistoryRequest,
} from './../business-entities/call-dealer-logs-model';

@Injectable({
  providedIn: 'root',
})
export class CallDealerLogsDataService {
  constructor(private dataService: DataService) {}

  async getCallDealerLogs(requestModel: CallDealerLogsRequestModal): Promise<GenericResponse<any>> {
    return this.dataService.Post<GenericResponse<any>>(Urls.GetCallDealerLogs, requestModel).toPromise();
  }
  async GetDealerWiseCallHistory(requestModel: DealerWiseCallHistoryRequest): Promise<GenericResponse<any>> {
    return this.dataService.Post<GenericResponse<any>>(Urls.GetDealerWiseCallHistory, requestModel).toPromise();
  }
}
